import React from 'react';
import PropTypes from 'prop-types';

import Picture from '../../Util/Picture/Picture';
import FlagView from '../Flag/FlagView';

import './shopTile.scss';

const ShopTileView = props => (
  <a href={props.url} className={'m-tile m-tile--medium m-tile--shop'} key={props.id}>
    <FlagView flag={props.flag} flagColor={props.flagColor} flagOrientation={props.flagOrientation} />
    <div className="m-tile__inner">
      <div className="m-tile__content">
        <div className="m-tile__headings">
          <div className={'m-tile__headline'}>{props.headline}</div>
          <div className={'m-tile__subheadline'}>{props.subline}</div>
        </div>
        <Picture class={'m-tile__shop-pic'} src={{ ...props.image }} disableZoom />
        <button className="a-button a-button--large a-button--blue">{props.buttonLabel}</button>
      </div>
    </div>
  </a>
);

ShopTileView.propTypes = {
  headline: PropTypes.string,
  subline: PropTypes.string,
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  url: PropTypes.string,
  buttonLabel: PropTypes.string,
  flag: PropTypes.string,
  flagColor: PropTypes.string,
  flagOrientation: PropTypes.string,
  image: PropTypes.shape({
    xxl: PropTypes.string,
    xl: PropTypes.string,
    lg: PropTypes.string,
    md: PropTypes.string,
    sm: PropTypes.string,
    default: PropTypes.string,
  }),

};

ShopTileView.defaultProps = {
  id: '',
  headline: '',
  subline: '',
  buttonLabel: '',
  image: {
    xxl: '',
    xl: '',
    lg: '',
    md: '',
    sm: '',
    default: '',
  },
  url: '/',
  lang: 'en',
  flag: '',
  flagColor: 'black',
  flagOrientation: 'left',
};

export default ShopTileView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Tiles/ShopTile/ShopTileView.jsx